'use client'

import { LeagueRanks } from "@/components/custom/leagues/league-ranks"

export function RightSidebar() {
  return (
    <aside className="w-full min-w-0 pt-6 pb-16 lg:sticky lg:top-5 overflow-hidden">
      <LeagueRanks />
    </aside>
  )
}
